export default __webpack_public_path__ + "static/media/NIST.3e8d0e7f.png";